export const PoweredBy = ({ className = "" }) => (
  <div
    data-testid="powered-by-watermark"
    className={`flex select-none items-center justify-center gap-1.5 py-5 ${className}`}
  >
    <span className="text-[10.5px] font-medium tracking-wide text-[#A1A1A6]">Powered by</span>
    <img
      src="/gigazip-logo.webp"
      alt="gigazip"
      className="h-[24px] w-auto opacity-45 mix-blend-multiply [filter:grayscale(1)] transition-all duration-200 hover:opacity-100 hover:mix-blend-normal hover:[filter:grayscale(0)]"
    />
  </div>
);

export default PoweredBy;
